import { useCallback } from "react"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { OK } from "helpers/data-statuses"
import type { DataStatus } from "helpers/data-statuses"

import "./style.scss"

export interface ForecastMeta {
  id: string
  name: string
  description?: string
}

interface ForecastProps {
  forecast: string | undefined
  onChange: (value: string | undefined) => void
  forecasts: ForecastMeta[]
  forecastsStatus: DataStatus
}

export default function Forecast({ forecast, onChange, forecasts, forecastsStatus }: ForecastProps) {
  const handleChange = useCallback((event: SelectChangeEvent<string>) => {
    const newValue = event.target.value
    onChange(newValue === "none" ? undefined : newValue)
  }, [onChange])
  const noForecasts = forecastsStatus !== OK || !forecasts

  return (
    <Box className="components_forecast">
      <FormControl className="forecast-select">
        <InputLabel id="forecast-select-label">Forecast</InputLabel>
        <Select
          labelId="forecast-select-label"
          id="select"
          value={forecast ?? "none"}
          onChange={handleChange}
          label="Forecast"
          autoWidth
          size="small"
        >
          <MenuItem value="none">
            No Forecast
          </MenuItem>
          <MenuItem value="impliedReturns">
            Implied Returns
          </MenuItem>
          {!noForecasts && forecasts.map((forecast) => (
            <MenuItem key={forecast.id} value={forecast.id}>
              {forecast.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
